<div class="footer-wrapper">
  This service is owned and operated by {{ brand.companyName }} on behalf of {{ businessName }}. For support, go to
  <a rel="noopener" target="_blank" [href]="brand.contactUrl">{{ brand.contactUrl }}</a>
</div>
